import {queryOptions} from '@tanstack/react-query';
import type {DocumentationContactNotesListParams} from 'api/v2';
import {
  documentationContactNotesList,
  documentationContactNotesPlacesOfServiceRetrieve,
} from 'api/v2';

export const contactNotesQueryKeys = {
  all: () => ['contactNotes'],
  lists: () => [...contactNotesQueryKeys.all(), 'list'],
  list: (params: DocumentationContactNotesListParams) => [
    ...contactNotesQueryKeys.lists(),
    params,
  ],
  placesOfService: (dateOfService: string) => [
    ...contactNotesQueryKeys.all(),
    'placesOfService',
    dateOfService,
  ],
};

const list = (params: DocumentationContactNotesListParams) =>
  queryOptions({
    queryKey: contactNotesQueryKeys.list(params),
    queryFn: () => documentationContactNotesList(params),
    select: (data) => data.data,
  });

const placesOfService = (dateOfService: string) =>
  queryOptions({
    queryKey: contactNotesQueryKeys.placesOfService(dateOfService),
    queryFn: () =>
      documentationContactNotesPlacesOfServiceRetrieve({dateOfService}),
    select: (data) => data.data,
    // Each date's catalog is fixed; a new version starts on a new date
    staleTime: Infinity,
  });

export const contactNotesQueryOptions = {
  list,
  placesOfService,
};
